import {
  TeacherPedagogySubform,
  type ResumeField,
} from "@user-management-context/primary/teacher/teacher-pedagogy-subform/teacher-pedagogy.subform";
import type { RequestState } from "@redux/state/shared-types";

interface Props {
  onUploadResume: (field: ResumeField, file: File) => void;
  onUploadMethodology: (rowIndex: number, file: File) => void;
  uploadProcessing: RequestState;
}

export const PedagogyStep = ({ onUploadResume, onUploadMethodology, uploadProcessing }: Props) => {
  return <TeacherPedagogySubform onUpload={onUploadResume} onUploadMethodology={onUploadMethodology} uploadProcessing={uploadProcessing} />;
};
